import { Component, OnInit } from '@angular/core';
import { User } from 'src/app/auth/models/user.model';
import { AuthService } from 'src/app/auth/services/auth.service';
import { DashboardStateServiceService } from '../../services/dashboard-state-service.service';
import moment from 'moment';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false
})
export class HomeComponent implements OnInit {
  user: User = new User();

  startDate = moment().subtract(1, 'w').format('YYYY-MM-DD');
  endDate = moment().format('YYYY-MM-DD');

  constructor(
    private authService: AuthService,
    private dashboardStateService: DashboardStateServiceService
  ) { }

  ngOnInit(): void {
    this.user = this.authService.getUser();
  }

  updateDate() {
    this.dashboardStateService.$datesChanged.next(0);
  }
}
